import { ManufacturerFilter } from "../data/search-data";
import { SearchView } from "./search-view";

export class CommercialSearchView extends SearchView {

    protected get manufacturerFilter(): ManufacturerFilter { return ManufacturerFilter.commercial; }

}

export class ResidentialSearchView extends SearchView {
    protected get manufacturerFilter(): ManufacturerFilter { return ManufacturerFilter.residential; }
}
